<template>
  <div v-if="shown" class="text-caption" :class="noteClass">
    <div v-if="part !== 'history'" class="d-flex flex-wrap align-center">
      <v-icon
        size="14"
        class="mr-1 text-grey-darken-1"
        :title="$t('acceptance.corrections.locked')"
      >
        mdi-lock-outline
      </v-icon>
      <v-btn
        v-if="canCorrect"
        size="x-small"
        variant="tonal"
        color="primary"
        :disabled="disabled"
        @click="$emit('correct', group)"
      >
        {{ $t("acceptance.corrections.correct") }}
      </v-btn>
    </div>
    <div
      v-for="item in part === 'action' ? [] : previous"
      :key="item.path"
      class="text-grey-darken-1 mt-1"
    >
      {{
        $t("acceptance.corrections.previous_line", {
          field: $t(spec(item.path).label),
          value: shownValue(item),
          date: dateOf(item),
        })
      }}
      <a
        href="#"
        class="acceptance-note-link"
        @click.prevent="$emit('open-log', item.correction.eventId)"
      >
        {{ $t("acceptance.corrections.view_log") }}
      </a>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  fieldSpec,
  previousValues,
  valueDisplay,
} from "@/components/Acceptance/corrections.mjs";

// The lock and "Correggi" of one frozen field group on a confirmed acceptance, with the previous
// value of each corrected field ("Valore precedente: … · corretto il …") linked to the log entry.
// A PRA case (Stage 2) passes its own field helpers (praCorrections.mjs PRA_FIELDSET).
export default {
  name: "AcceptanceCorrectionNote",
  props: {
    // Correction group: "owner", "arrival.date", "checklist.plates", ...
    group: { type: String, required: true },
    // Shown only on a confirmed acceptance.
    frozen: { type: Boolean, default: false },
    // GET `corrections`: latest correction per field path
    corrections: { type: Object, default: () => ({}) },
    // GET `canCorrect` (Manager / Admin, confirmed). Cosmetic; the API decides.
    canCorrect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    // "all": lock, button and previous values; "action": lock and button only (for a group's title
    // line); "history": previous values only (full width under the group's fields).
    part: {
      type: String,
      default: "all",
      validator: (value) => ["all", "action", "history"].includes(value),
    },
    // { fieldSpec, previousValues, valueDisplay } instead of the Stage 1 ones
    fieldset: { type: Object, default: null },
  },
  emits: ["correct", "open-log"],
  computed: {
    helpers() {
      return this.fieldset || { fieldSpec, previousValues, valueDisplay };
    },
    previous() {
      return this.helpers.previousValues(this.corrections, this.group);
    },
    shown() {
      if (!this.frozen) return false;
      return this.part !== "history" || this.previous.length > 0;
    },
    noteClass() {
      if (this.part === "action") return "d-inline-flex";
      if (this.part === "history") return "mb-2";
      return "acceptance-note";
    },
  },
  methods: {
    spec(path) {
      return this.helpers.fieldSpec(path);
    },
    shownValue(item) {
      const display = this.helpers.valueDisplay(item.path, item.from);
      if (display.empty) return "—";
      return display.key ? this.$t(display.key) : display.text;
    },
    dateOf(item) {
      return moment(item.correction.correctedAt).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.acceptance-note {
  min-height: 22px;
}
.acceptance-note-link {
  color: inherit;
}
</style>
